export default __webpack_public_path__ + "static/media/보석비누 클래스_웹.6dd802ec.jpg";